import i18next from "i18next";
import { Console } from "console";
import { IQuantity } from "../../../../../common/models/quantity.model";
import { Quantity } from "../../../../../common/models/quantity.model";
import { OrderTypes } from "../../../../../orders/models/OrderTypes.enum";
import { translateOrderTypeName } from "../../../../../common/enums/orderTypes.enum";

export const generatePickUpPointsCommands = (
  quantity: IQuantity,
  actions: any,
  orderTypes: any,
  isActive: boolean
) => {
  const t = i18next.getFixedT(null, "admin");

  const itemsArr = orderTypes.map(({ key, text }: any) => {
    let icon = { iconProps: {} };

    if (text === OrderTypes.VEHICLE) {
      icon = { iconProps: { iconName: "Car" } };
    } else if (text === OrderTypes.CONTAINER) {
      icon = { iconProps: { iconName: "Inbox" } };
    } else if (text === OrderTypes.WEIGHT) {
      icon = { iconProps: { iconName: "Weights" } };
    }

    return {
      key: key,
      id: key,
      text: translateOrderTypeName(text, t),
      iconProps: icon.iconProps,
      onClick: actions.verifyPickuPoint,
    };
  })

  if (quantity === Quantity.NONE) {
    return [
      {
        key: "add",
        text: t("nav.add"),
        iconProps: { iconName: "add" },
        name: "add",
        onClick: actions.toggle,
      },
    ];
  } else {
    if (isActive) {
      return [
        {
          key: "edit",
          text: t("nav.edit"),
          iconProps: { iconName: "edit" },
          name: "add",
          onClick: actions.toggle,
        },

      ];
    } else {
      return [
        {
          key: "verify",
          text: t("nav.verify"),
          iconProps: { iconName: "send" },
          name: "verify",
          subMenuProps: {
              items: [...itemsArr],
          },
      }
      ];
    }
  }
};
